import { combineReducers } from 'redux';

import auth from './auth.reducer';
import billing from './billing.reducer';
import cart from './cart.reducer';
import checkout from './checkout.reducer';
import delivery from './delivery.reducer';
import favourite from './favourite.reducer';
import library from './library.reducer';
import orders from './orders.reducer';
import product from './product.reducer';
import quotationReducer from './quotation.reducer';
import sales from './sales.reducer';
import upload from './upload.reducer';

export default combineReducers({
  auth,
  product,
  cart,
  billing,
  delivery,
  orders,
  favourite,
  checkout,
  library,
  sales,
  upload,
  quotations: quotationReducer,
});
